export class TranslateSettings {
  // #region Properties

  public static DEFAULT_LANGUAGE: string = 'es';
  public static TRANSLATE_FILES_EXTENSION: string = '.json';
  public static TRANSLATE_FILES_PATH: string = './assets/translations/';
  public static USE_DEFAULT_LANG: boolean = true;

  // #endregion Properties
}
